// extracted by mini-css-extract-plugin
export default {"container":"App_container__qYw+Y","skipMain":"App_skipMain__Hx1sV"};